export const translate = (
  key: string,
  dictionary: Record<string, any> | null,
  params: Record<string, string | number> = {},
  fallback: string = key
): string => {
  if (!dictionary) return fallback;

  const value = key.split('.').reduce((obj, k) => obj && typeof obj === 'object' ? obj[k] : undefined, dictionary as any);
  if (value === undefined) return fallback;
  
  return Object.keys(params).reduce(
    (result, paramKey) => result.replace(new RegExp(`{${paramKey}}`, 'g'), String(params[paramKey])),
    String(value)
  );
};